import SuccessIcon from 'assets/icons/base/success-icon.svg';
import { useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { costFormat } from 'utils/cost-format';
import { PaymentWrapper } from 'views/components/base/payment-wrapper';
import { SendCheck } from 'views/forms/base/send-check';

const PaymentSuccess = () => {
  const { paymentData, isPayment } = useAppSelector((state) => state.payment);
  const { t } = useTranslate();

  return (
    <PaymentWrapper className="bg-skstore-blue md:max-w-[387px] w-full flex items-center">
      <div className="text-white flex flex-col text-center md:w-full mx-auto md:mx-0 md:text-left md:justify-between h-full">
        <div className="block md:hidden mx-auto mb-4">
          <img src={SuccessIcon} alt="success" />
        </div>
        <div>
          <h3 className="text-xl leading-6 font-bold">
            {isPayment ? t('lang.pay_successful') : t('lang.payout_successful')}
          </h3>
        </div>
        <div className="my-12 md:my-0">
          <dl className="mb-4 last:mb-0">
            <dt className="uppercase text-base font-semibold md:font-normal leading-3 tracking-[2px] mb-2 opacity-60">
              {t('lang.order_number')}
            </dt>
            <dd className="text-2xl md:text-xl leading-5 font-bold">{paymentData?.ID}</dd>
          </dl>
          <dl className="mb-4 last:mb-0">
            <dt className="uppercase text-base font-semibold md:font-normal leading-3 tracking-[2px] mb-2 opacity-60">
              {t('amount')}
            </dt>
            <dd className="text-2xl md:text-xl leading-5 font-bold">
              {paymentData?.fix
                ? costFormat(Math.abs(Number(paymentData.amount)))
                : costFormat(Math.abs(Number(paymentData?.amount)))}{' '}
              KZT
            </dd>
          </dl>
        </div>
        <SendCheck />
      </div>
    </PaymentWrapper>
  );
};

export { PaymentSuccess };
